 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Demo":"Demo","activityDetail~calendar~community~community-circle~content~feed~inspiration_new~object-detail~partic~263addc5":"activityDetail~calendar~community~community-circle~content~feed~inspiration_new~object-detail~partic~263addc5","activityDetail~calendar~community~content~feed~inspiration_new~object-detail~project":"activityDetail~calendar~community~content~feed~inspiration_new~object-detail~project","activityDetail~calendar~community~feed~project":"activityDetail~calendar~community~feed~project","calendar":"calendar","activityDetail~community~creation~feed~profile~project":"activityDetail~community~creation~feed~profile~project","activityDetail":"activityDetail","community":"community","feed":"feed","project":"project","object-detail":"object-detail","content":"content","inspiration_new":"inspiration_new","community-circle":"community-circle","participants":"participants","creation":"creation","profile":"profile","activityList":"activityList","login":"login","communities~my-comunities":"communities~my-comunities","communities":"communities","my-comunities":"my-comunities","dashboard":"dashboard","explorer~inspirations":"explorer~inspirations","explorer":"explorer","inspirations":"inspirations","folder":"folder","groups":"groups","import":"import","inspiration":"inspiration","login_microsoft":"login_microsoft","loginlocal":"loginlocal","session-detail":"session-detail","sessions":"sessions","user":"user"}[chunkId]||chunkId) + "." + {"Demo":"49b8d2a8","activityDetail~calendar~community~community-circle~content~feed~inspiration_new~object-detail~partic~263addc5":"a7763a04","activityDetail~calendar~community~content~feed~inspiration_new~object-detail~project":"7b7ea201","activityDetail~calendar~community~feed~project":"09e71b2a","calendar":"12170b58","activityDetail~community~creation~feed~profile~project":"58e9aea2","activityDetail":"8cc82e13","community":"3974ceb0","feed":"b1f3923c","project":"eeb7138e","chunk-8410122e":"00e55866","object-detail":"4548cbfb","content":"4f288731","inspiration_new":"2d512e57","community-circle":"797eaffe","participants":"b0ec0cbd","creation":"7e56a98e","profile":"333e6c18","activityList":"bdee3d70","chunk-1bb2ef0b":"64652292","chunk-2d0c8da8":"a0311fa0","chunk-767ca31e":"299a29c8","chunk-5a94f71b":"53c66ac1","login":"d14e17ac","communities~my-comunities":"dd241ccd","communities":"6da9b5d4","my-comunities":"e4daeb68","dashboard":"291120a6","explorer~inspirations":"ce107270","explorer":"10637a59","inspirations":"434cbbab","folder":"928ec1ac","groups":"ab58fb18","import":"6717fbe1","inspiration":"4d661f89","login_microsoft":"01213eae","loginlocal":"25c1caf0","session-detail":"34d5c4b9","sessions":"7607dfcd","user":"7d71a5a6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Demo":1,"activityDetail~calendar~community~content~feed~inspiration_new~object-detail~project":1,"activityDetail~calendar~community~feed~project":1,"calendar":1,"activityDetail~community~creation~feed~profile~project":1,"activityDetail":1,"community":1,"feed":1,"project":1,"chunk-8410122e":1,"object-detail":1,"content":1,"inspiration_new":1,"community-circle":1,"participants":1,"creation":1,"profile":1,"activityList":1,"chunk-1bb2ef0b":1,"chunk-767ca31e":1,"chunk-5a94f71b":1,"login":1,"communities~my-comunities":1,"communities":1,"dashboard":1,"explorer~inspirations":1,"explorer":1,"inspirations":1,"folder":1,"groups":1,"import":1,"inspiration":1,"session-detail":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Demo":"Demo","activityDetail~calendar~community~community-circle~content~feed~inspiration_new~object-detail~partic~263addc5":"activityDetail~calendar~community~community-circle~content~feed~inspiration_new~object-detail~partic~263addc5","activityDetail~calendar~community~content~feed~inspiration_new~object-detail~project":"activityDetail~calendar~community~content~feed~inspiration_new~object-detail~project","activityDetail~calendar~community~feed~project":"activityDetail~calendar~community~feed~project","calendar":"calendar","activityDetail~community~creation~feed~profile~project":"activityDetail~community~creation~feed~profile~project","activityDetail":"activityDetail","community":"community","feed":"feed","project":"project","object-detail":"object-detail","content":"content","inspiration_new":"inspiration_new","community-circle":"community-circle","participants":"participants","creation":"creation","profile":"profile","activityList":"activityList","login":"login","communities~my-comunities":"communities~my-comunities","communities":"communities","my-comunities":"my-comunities","dashboard":"dashboard","explorer~inspirations":"explorer~inspirations","explorer":"explorer","inspirations":"inspirations","folder":"folder","groups":"groups","import":"import","inspiration":"inspiration","login_microsoft":"login_microsoft","loginlocal":"loginlocal","session-detail":"session-detail","sessions":"sessions","user":"user"}[chunkId]||chunkId) + "." + {"Demo":"805b3fc3","activityDetail~calendar~community~community-circle~content~feed~inspiration_new~object-detail~partic~263addc5":"31d6cfe0","activityDetail~calendar~community~content~feed~inspiration_new~object-detail~project":"fa0a4b91","activityDetail~calendar~community~feed~project":"9b1f152b","calendar":"de36a45d","activityDetail~community~creation~feed~profile~project":"4988f710","activityDetail":"9588e2dd","community":"dc6bffcc","feed":"3d40355d","project":"c17cf537","chunk-8410122e":"80d8a5b6","object-detail":"18d56658","content":"14c17506","inspiration_new":"4e61e344","community-circle":"452d1551","participants":"2282fe75","creation":"8d9a3b29","profile":"1e9ceb9e","activityList":"a1893589","chunk-1bb2ef0b":"ae6c7861","chunk-2d0c8da8":"31d6cfe0","chunk-767ca31e":"d40e3924","chunk-5a94f71b":"7399c9b5","login":"a859cd14","communities~my-comunities":"2e12d796","communities":"af982e6a","my-comunities":"31d6cfe0","dashboard":"cd7824ed","explorer~inspirations":"f9ddaf11","explorer":"c1ea15ef","inspirations":"904f747f","folder":"8c34dce7","groups":"783fbadf","import":"d9b5778e","inspiration":"a4afb696","login_microsoft":"31d6cfe0","loginlocal":"31d6cfe0","session-detail":"e53a5ac6","sessions":"31d6cfe0","user":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
